import React from 'react'
import ProductsGrid from './../../components/products-grid.component'
import { StoreProductService } from './../../../../services/store-product.service'

const MoveflexStoreContent = () => (
	<React.Fragment>
		<ProductsGrid fetchData={StoreProductService.list} />
	</React.Fragment>
)

export default MoveflexStoreContent
